<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="10">
                    <h3>{{ this.$route.name + ' (Somente E-mail)' }}</h3>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-row>
              <b-col md="8" sm="12">
                  <b-form-group label="E-mail:">
                      <b-form-input type="text" v-model="filtros.filter"></b-form-input>
                  </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2" sm="12">
                <b-form-group label="Data da última situação:">
                  <b-input-group>
                    <b-form-datepicker
                      locale="pt-BR"
                      size="sm"
                      v-model="filtros.data"
                      placeholder="dd/mm/aaaa"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    ></b-form-datepicker>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="3" sm="12">
                <b-form-group>
                  <b-form-group label="Situação:">
                    <b-form-select v-model="filtros.situacao" id="checkbox-group-2" :options="situacoes"></b-form-select>
                  </b-form-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <b-button @click="resetForm()" block>
                    <span>Limpar Filtros</span>
                </b-button>
              </b-col>
            </b-row>
        </b-card-body>
        <b-row>
          <b-col sm="12">
            <b-col sm="12">
              <b-table
                striped
                hover
                bordered
                small
                responsive
                :items="envios"
                filter
                :current-page="pagina"
                :fields="fields"
                per-page="20"
                :show-empty="true"
                empty-text="Não há envios para o formulário..."
              >

                <template v-slot:cell(data)="row">
                  {{ format_date(row.item.updated_at) }}
                </template>

                <template v-slot:cell(situacao)="row">
                  {{ row.item.status === 'RP' ? 'Respondido' : row.item.status === 'RE' ? 'Reenviado' : 'Sem Resposta' }}
                </template>

              </b-table>

              <label> Exibindo página {{ pagina }} de {{ totalDePaginas }}, total de {{ envios.length }} registros.</label>

              <b-pagination
                v-model="pagina"
                :total-rows="envios.length"
                per-page="20"
                size="sm"
                align="left"
                ></b-pagination>

            </b-col>
          </b-col>
        </b-row>
        <b-card-footer>
          <b-col md="3">
            <b-button block variant="secondary" @click="voltar()">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-card-footer>
      </b-card>
    </span>
</template>

<script>
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

miniToastr.init()

export default {
  name: 'RespostasQuestionario',
  components: {
    Pagination,
    Multiselect
  },
  created () {
    if (!this.can('questionario.showAnswer')) {
      this.$router.push('/')
    } else {
      this.$store.dispatch('getPerfis')
      this.$store.dispatch('getEnvios', {id: this.$route.params.id})
    }
  },
  data () {
    return {
      situacoes: [
        { value: '', text: 'Selecione' },
        { value: 'EN', text: 'Sem Resposta' },
        { value: 'RE', text: 'Reenviada' },
        { value: 'RP', text: 'Respondida' }
      ],
      tipoEnvio: [
        { value: '', text: 'Selecione' },
        { value: 'email', text: 'E-mail' },
        { value: 'link', text: 'Link' }
      ],
      filtros: {
        filter: '',
        data: '',
        situacao: ''
      },
      pagina: 1,
      fields: [
        { key: 'email',
          label: 'E-mail'},
        { key: 'data',
          label: 'Data da Última Situação',
          thStyle: {
            'text-align': 'center'
          },
          tdClass: 'text-center'},
        { key: 'situacao',
          label: 'Situação',
          thStyle: {
            'text-align': 'center'
          },
          tdClass: 'text-center'}
      ]
    }
  },
  computed: {
    perfilAtual () {
      return this.$store.state.questionario.perfilAtual
    },
    totalDePaginas () {
      let total = 0
      let calc = 0

      calc = (this.envios.length / 20)

      if (calc % 1 !== 0) {
        total = parseInt(calc + 1)
      }

      return total
    },
    envios () {
      return this.$store.state.envio.envios
    },
    perfis () {
      return this.$store.state.perfil.lista
    }
  },
  watch: {
    'filtros.filter': function () {
      this.$store.dispatch('getEnvios',
        {id: this.$route.params.id,
          filter: this.filtros.filter,
          data: this.filtros.data,
          situacao: this.filtros.situacao})
    },
    'filtros.data': function () {
      this.$store.dispatch('getEnvios',
        {id: this.$route.params.id,
          filter: this.filtros.filter,
          data: this.filtros.data,
          situacao: this.filtros.situacao})
    },
    'filtros.situacao': function () {
      this.$store.dispatch('getEnvios',
        {id: this.$route.params.id,
          filter: this.filtros.filter,
          data: this.filtros.data,
          situacao: this.filtros.situacao})
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    resetForm () {
      this.filtros.filter = ''
      this.filtros.data = ''
      this.filtros.situacao = ''
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    voltar () {
      this.$router.push('/formulario/respostas/' + this.$route.params.id)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/cliente/questionarios/VisualizarDestinatarios.vue